import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { EXPERIMENT_VIEWED } from '../../constants/analytics-events';
import Global from '../../store/global-selectors';
import { Segment } from '../../services/analytics-services/segment';
import { useEnableHomePage } from '../../feature-flags/hooks/use-enable-home-page';

const GROW_524 = 'GROW_524';

export const useTrackGrow524Experiment = () => {
  const variant = useEnableHomePage();
  const sellerId = useSelector(Global.selectSellerSellerId)?.toString();
  const userId = useSelector(Global.selectUserCurrentUserId);

  return useCallback(async () => {
    Segment.trackEvent(EXPERIMENT_VIEWED, {
      experiment_id: GROW_524,
      group_variation: variant,
      seller_id: sellerId,
      user_id: userId,
      enrollment_date: new Date(),
    });
  }, [sellerId, userId, variant]);
};
